import Header from './components/Header';
import Hero from './components/Hero';
import RankingSection from './components/RankingSection';
import FeaturesSection from './components/FeaturesSection';
import CardsSection from './components/CardsSection';
import CommentsSection from './components/CommentsSection';
import FaqSection from './components/FaqSection';
import CarouselSection from './components/CarouselSection';
import IndexSection from './components/IndexSection';
import TopicsSection from './components/TopicsSection';
import AboutSection from './components/AboutSection';
import AppSection from './components/AppSection';
import UpdatesSection from './components/UpdatesSection';
import MediaSection from './components/MediaSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen font-body text-foreground-900 bg-background-50">
      <Header />
      <main>
        <Hero />
        <RankingSection />
        <FeaturesSection />
        <CardsSection />
        <CommentsSection />
        <FaqSection />
        <CarouselSection />
        <IndexSection />
        <TopicsSection />
        <AboutSection />
        <AppSection />
        <UpdatesSection />
        <MediaSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}